import filter from "../filter";

export default ({config, action, data}: {config: any, action: string, data: any}) => {
    return !config?.actions?.[action]?.privilege
        ||
        filter({
            filter: config.actions[action].privilege,
            data
        });
}